import React from 'react';
import closeIcon from '../../assets/close_icon.svg'

export const PopupHeader = ({
  onClose,
  title,
}) => (
  <header className='popup-header'>
    <span className='popup-title'>
      {title}
    </span>
    <div className='popup-close' onClick={onClose}>
      <img className='popup-close_icon' src={closeIcon} alt='close'/>
    </div>
  </header>
);
